import { useRef, useEffect } from "react";
import { SendMessageToServer } from "./SendMessageToServer";

function WebSocketConnection({
    token,
    setSocket,
    clientIDRef,
    onMessagesUpdate,
    onAuthorizationResult,
    playerName,
    iconIndex
}) {
    //const defaultAddress = `ws://192.168.18.8:8080?token=${token}`; //local server
    const defaultAddress = `wss://ws.gamepads.org/ws`; // production
    const hasConnected = useRef(false);

    useEffect(() => {
        if (hasConnected.current)
            return;

        hasConnected.current = true;
        const websocket = new WebSocket(defaultAddress);

        websocket.onopen = () => {
            setSocket(websocket);  // ← Direct call, not through ref!
        };

        websocket.onmessage = (event) => {
            try {
                const parsedMsg = JSON.parse(event.data);

                // First message from server - set client ID and authenticate
                if ((parsedMsg.SentFromServer === true && clientIDRef.current === "")) {
                    clientIDRef.current = parsedMsg.TargetID;

                    const authData = `${playerName},${iconIndex},${token}`;
                    SendMessageToServer(websocket, clientIDRef, `${authData}`, false); // Send player info to server
                }
                else if (clientIDRef.current !== "" && parsedMsg.Content) {
                    const content = parsedMsg.Content.trim();
                    if (content === "AUTH_SUCCESS" || content.includes("authenticated")) {
                        onAuthorizationResult(true);
                    }
                    else if (content === "AUTH_FAILED" || content.includes("Invalid") || content.includes("Wrong")) {
                        onAuthorizationResult(false);
                        clientIDRef.current = "";
                    }
                    else {
                        // Regular message - pass to parent
                        if (onMessagesUpdate) {
                            onMessagesUpdate(event.data);
                        }
                    }
                }
                // Handle disconnect command from server
                if (parsedMsg.Content === "DISCONNECTED" || parsedMsg.Content === "Disconnected") {
                    setSocket(null);  // ← Direct call
                    window.location.reload();
                }

            } catch (error) {
                console.error("❌ Failed to parse message:", event.data);
                console.error("❌ Error details:", error);
                onAuthorizationResult(false);  // ← Direct call
            }
        };

        websocket.onclose = (event) => {
            if (event.code === 1007)
                onAuthorizationResult(false);  // ← Direct call

            setSocket(null);  // ← Direct call
        };

        websocket.onerror = (error) => {
            console.error('❌ WebSocket Error:', error);
            console.error('   Type:', error.type);
            onAuthorizationResult(false);  // ← Direct call
        };

        // Cleanup on unmount
        return () => {
            if (websocket.readyState === WebSocket.OPEN) {
                websocket.close();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty deps - only run once!

    return null;
}

export default WebSocketConnection;